import { useState, useEffect } from "react";
import { FaEthereum } from "react-icons/fa";
import {
  AiOutlineLoading3Quarters,
  AiOutlineCloseCircle,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { StepBar } from "../common/steps";
import { supabase } from "../auth/supabaseClient";
import { useAuth } from "../../contexts/AuthContext";

import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultWallets, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import {
  chain,
  configureChains,
  createClient,
  WagmiConfig,
  useAccount,
} from "wagmi";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";
import { ConnectButton } from "@rainbow-me/rainbowkit";

const { chains, provider } = configureChains(
  [chain.polygon],
  [
    alchemyProvider({ apiKey: process.env.REACT_APP_ALCHEMY_API_KEY }),
    publicProvider(),
  ]
);

const { connectors } = getDefaultWallets({
  appName: "Ribbon",
  chains,
});
const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

function AccountAddressesWidget(props) {
  const { user } = useAuth();

  const [defaultAddress, setDefaultAddress] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchAccountAddresses();
    }
  }, [user, props.updateAddresses]);

  function displayAddress(address) {
    return `${address.slice(0, 4)}...${address.slice(-4)}`;
  }

  function fetchAccountAddresses() {
    console.log("fetch");
    setLoading(true);
    supabase
      .from("addresses")
      .select("*")
      .eq("user_id", user.id)
      .then((res) => {
        res.data.map((userAddreRelation) => {
          if (userAddreRelation.default) {
            setDefaultAddress(userAddreRelation.address);
          }
          setAddresses([...addresses, userAddreRelation]);
        });
        setLoading(false);
      });
  }

  async function removeAddress(userAddreRelation) {
    setLoading(true);
    const { error } = await supabase
      .from("addresses")
      .delete()
      .eq("address", userAddreRelation.address);
    if (error) {
      console.log(error);
    }
    setAddresses(
      addresses.filter((a) => a.address !== userAddreRelation.address)
    );
    setLoading(false);
  }

  function createAddressElements() {
    return addresses.map((userAddreRelation) => {
      return (
        <div
          className="grid grid-cols-3 bg-purpler-100 rounded-sm justify-middle items-right"
          key={userAddreRelation.address}
        >
          <div className="p-2 text-s">
            {displayAddress(userAddreRelation.address)}
          </div>
          {userAddreRelation.default ? (
            <div className="p-2 pl-2 text-s">(default)</div>
          ) : null}
          <div className="p-2">
            <button
              onClick={() => {
                removeAddress(userAddreRelation);
              }}
            >
              <AiOutlineCloseCircle size={20} />
            </button>
          </div>
        </div>
      );
    });
  }

  if (loading) {
    return (
      <div className="grid place-items-center">
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
    );
  } else if (addresses.length === 0) {
    return (
      <p className="mb-5 text-xs">No addresses associated with account. </p>
    );
  } else {
    return createAddressElements();
  }
}

function ConnectWidget(props) {
  const { address, connector, isConnected } = useAccount();
  const { user } = useAuth();

  async function addAddressToAccount() {
    if (isConnected) {
      const { error } = await supabase
        .from("addresses")
        .insert([{ user_id: user.id, address: address, default: true }]);
      if (error) {
        console.log("error", error);
      }
    }

    props.setUpdateAddresses(!props.updateAddresses);
  }

  if (isConnected) {
    return (
      <div className="grid grid-cols-2 gap-2">
        <ConnectButton showBalance={false} />
        <button className="text-purpler" onClick={addAddressToAccount}>
          Add to Ribbon
        </button>
      </div>
    );
  } else {
    return <ConnectButton showBalance={false} />;
  }
}

function SetWallet() {
  const navigate = useNavigate();

  const [updateAddresses, setUpdateAddresses] = useState(false);

  const handleNext = () => {
    navigate("/set-team");
  };

  return (
    <div>
      <StepBar
        steps={[
          { label: "Profile", status: "complete" },
          { label: "Wallet", status: "current" },
          { label: "Team", status: "incomplete" },
          { label: "Plan", status: "incomplete" },
        ]}
      />
      <div className="rounded max-w-xs min-w-xs p-5 bg-slate-100">
        <h1 className="text-2xl font-bold mb-5 flex items-center">
          <FaEthereum size={40} className="mr-2" />
          Your Wallet
        </h1>
        <p className="mb-5">
          Connect your Polygon wallet to own your Ribbon awards as you receive
          them.
        </p>
        <div className="flex justify-center mb-5">
          <ConnectWidget
            setUpdateAddresses={setUpdateAddresses}
            updateAddresses={updateAddresses}
          />
        </div>
        <div className="mb-5">
          <AccountAddressesWidget updateAddresses={updateAddresses} />
        </div>
        <button
          onClick={handleNext}
          className="bg-purpler text-white font-bold py-2 px-4 rounded"
        >
          Next
        </button>
        <button
          onClick={handleNext}
          className=" text-purpler font-bold py-2 px-4 rounded"
        >
          Skip
        </button>
      </div>
    </div>
  );
}

export default function SetWalletWrapped() {
  return (
    <WagmiConfig client={wagmiClient}>
      <RainbowKitProvider chains={chains}>
        <SetWallet />
      </RainbowKitProvider>
    </WagmiConfig>
  );
}
